import React, { useState, useEffect } from 'react';
import { MdLaptop, MdEdit, MdDelete } from 'react-icons/md';
import AddSystem from './AddSystem';
import { searchSytemApi } from '~/api';
import { DropDown } from '~/components';
import { Grid } from '~/components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { Portal } from '~/components';
import DeleteSystemSearch from './DeleteSystemSearch';

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 pr-4 border-b text-sm'
}; 

const SystemsSearched = () => {
    const [editSystemSearch, setEditingSearchSystem] = useState(false);
    const [systemSearchData, setSearchSystemData] = useState({});
    const [addSystemSearchModalOpen, setAddSystemSearchModalOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [idSystemSearch, setIdSearchSystem] = useState(0);
    const [nameSystemSearch, setNameSearchSystem] = useState('');

    const openSystemSearchModal = () => {
        setAddSystemSearchModalOpen(true);
        setEditingSearchSystem(false);
    };

    const closeSystemSearchModal = () => {
        setAddSystemSearchModalOpen(false);
    };

    const onEditClick = (data) => {
        setEditingSearchSystem(true);
        setSearchSystemData(data);
        setAddSystemSearchModalOpen(true);
    };

    const onDeleteClick = (data) => {
        setDeleteModalOpen(true);
        setIdSearchSystem(data.id);
        setNameSearchSystem(data.name);
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
    };

    useEffect(() => {
        let mounted = true;

        const fetchData = async() => {
            if(mounted) {
                const searchSystemsData = await searchSytemApi
                    .getSearchSystems()
                    .then(systems => systems.filter(s => !s.internal));

                setRows(searchSystemsData); 
                setLoading(false);
            }
        };

        fetchData();

        return () => mounted = false;
    }, []); 


    const columns = [
        { 
            title: 'System Name', 
            field: 'name',
            headerClassName,
            props
        },
        {
            title: 'Action',
            canSort: false,
            cell: ({ data }) => {
                return (
                    <span className="flex justify-end">
                        <DropDown
                            wrapperClass="rounded-md border bg-white z-20 filter drop-shadow-xl right-1/4 top-full mt-1"
                            iconClass="text-white ml-2"
                            iconSize='1.25em'
                            buttonClass="py-1 pl-3 pr-2 bg-blue-50 text-white focus:outline-none rounded-full flex items-center justify-center"
                            text='Actions'>
                            <section className="flex flex-col items-stretch w-48 text-gray-80">
                                <p className="font-semibold text-sm p-4 py-2">Action</p>
                                <button className="btn btn-link py-2 px-4 hover:bg-blue-10 flex items-center" 
                                    onClick={() => onEditClick(data)}>
                                    <MdEdit />
                                    <span className="ml-2">Edit </span>
                                </button>
                                <button className="btn btn-link py-2 px-4 hover:bg-blue-10 flex items-center" 
                                    onClick={() => onDeleteClick(data)}>
                                    <MdDelete />
                                    <span className="ml-2">Delete </span>
                                </button>
                            </section>
                        </DropDown>
                    </span>
                );
            },
            headerClassName: headerClassName + ' pr-10 flex justify-end',
            props
        }
    ];
    
    return (
        <>
            <div className="mt-16 mb-4 w-full flex flex-row justify-between">
                <div className="justify-start flex flex-col">
                    <h2 className="text-2xl text-blue-60 font-bold mb-2">Systems Searched</h2>
                    <p>Manage Systems Searched menu options on the Lot Lookup Search page.</p>
                </div>
                <div>
                    <button onClick={openSystemSearchModal} className=" py-2 px-4 bg-blue-50 text-white text-sm rounded-full flex items-center">
                        <MdLaptop />
                        <span className="ml-1">Add System</span>
                    </button>
                </div>
            </div>
            {isLoading && (
                <Portal id="loading-modal">
                    <div className="flex items-center justify-center h-screen w-screen bg-gray-400 opacity-70 z-50 fixed top-0 left-0 translate-y-1/2 -translate-x-1/2">
                        <AiOutlineLoading3Quarters className="animate-spin text-blue-30 font-bold" size="4rem" />
                    </div>
                </Portal>
            )}
            {rows.length > 0 && 
                <Grid 
                    className='w-full text-sm'
                    rowSelect
                    data={rows}
                    columns={columns}
                    usePagination={true}
                /> 
            }
            <AddSystem 
                filtersOpen={addSystemSearchModalOpen} 
                filtersClose={closeSystemSearchModal}
                editSystemSearch={editSystemSearch}
                systemSearchData={systemSearchData}
            />
            <DeleteSystemSearch 
                filtersOpen={deleteModalOpen} 
                filtersClose={closeDeleteModal}
                id={idSystemSearch}
                systemSearchName={nameSystemSearch}  
            />
        </>
    );
};

export default SystemsSearched;